import { render, staticRenderFns } from "./BatchImport.vue?vue&type=template&id=a25c30dc&scoped=true&"
import script from "./BatchImport.vue?vue&type=script&lang=js&"
export * from "./BatchImport.vue?vue&type=script&lang=js&"
import style0 from "./BatchImport.vue?vue&type=style&index=0&id=a25c30dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25c30dc",
  null
  
)

export default component.exports